import React, {Component} from 'react'
import * as firebase from 'firebase';
import MetaTags from 'react-meta-tags';
export default class HealthManagementTool extends Component {
  constructor() {
    super();
    this.state = {
      height: '',
      weight: '',
      gender: false,
      bmi: '',
      waistLine: '',
      hipsLine:'',
      activityAmount: '',
      waistLineAndHipsLineAns: false,
      send: false,
      loading: false
    }
    this.handleChangeGender = this.handleChangeGender.bind(this);
    this.handleChangeHeight = this.handleChangeHeight.bind(this);
    this.handleChangeWeight = this.handleChangeWeight.bind(this);
    this.handleChangeWaistLine = this.handleChangeWaistLine.bind(this);
    this.handleChangeHipsLine = this.handleChangeHipsLine.bind(this);
    this.handleChangeGenderActivityAmount = this.handleChangeGenderActivityAmount.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  handleChangeGender(event) {
    this.setState({gender: event.target.value});
  }
  handleChangeHeight(event) {
    this.setState({height: event.target.value});
  }
  handleChangeWeight(event) {
    this.setState({weight: event.target.value});
  }
  handleChangeWaistLine(event) {
    this.setState({waistLine: event.target.value});
  }
  handleChangeHipsLine(event) {
    this.setState({hipsLine: event.target.value});
  }
  handleChangeGenderActivityAmount(event) {
    this.setState({activityAmount: event.target.value});
  }
  handleSave(event) {
    var userId = firebase.auth().currentUser.uid
    const rootRef = firebase.database().ref('users/').child(userId).child('UserProfile')
    rootRef.update({
      gender: this.state.gender,
      height: this.state.height,
      weight: this.state.weight,
      waistLine: this.state.waistLine ? this.state.waistLine : null,
      hipsLine: this.state.hipsLine ? this.state.hipsLine : null,
      activityAmount: this.state.activityAmount ? this.state.activityAmount : null,
      bmi: Math.round(this.state.weight / (( this.state.height / 100 ) * ( this.state.height / 100 ) ))
    });
  }
  componentDidMount() {
    window.scrollTo(0,0)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        var userId = firebase.auth().currentUser.uid
        const rootRef = firebase.database().ref('users/').child(userId).child('UserProfile')
        rootRef.on('value', snap => {
          this.setState({
            height: snap.val().height,
            weight: snap.val().weight,
            gender: snap.val().gender,
            bmi: snap.val().bmi,
            waistLine: snap.val().waistLine,
            hipsLine: snap.val().hipsLine,
            activityAmount: snap.val().activityAmount,
            answer: snap.val().answer
          })
          if(this.state.bmi > 24) {
            rootRef.update({
              answer: '您的體重過重了喔'
            })
            if(this.state.activityAmount === 'mildWork') {
              this.setState({
                calorie: (25 *  this.state.weight)
              })
            } else if (this.state.activityAmount === 'moderateWork') {
              this.setState({
                calorie: (30 *  this.state.weight)
              })
            } else {
              this.setState({
                calorie: (35 *  this.state.weight)
              })
            }
            
          } else if (this.state.bmi < 18.5) {
            rootRef.update({
              answer: '您的體重過輕了'
            })
            if(this.state.activityAmount === 'mildWork') {
              this.setState({
                calorie: (35 *  this.state.weight)
              })
            } else if (this.state.activityAmount === 'moderateWork') {
              this.setState({
                calorie: (40 *  this.state.weight)
              })
            } else {
              this.setState({
                calorie: (45 *  this.state.weight)
              })
            }
          } else {
            rootRef.update({
              answer: '您的體重非常標準喔'
            })
            if(this.state.activityAmount === 'mildWork') {
              this.setState({
                calorie: (30 *  this.state.weight)
              })
            } else if (this.state.activityAmount === 'moderateWork') {
              this.setState({
                calorie: (35 *  this.state.weight)
              })
            } else {
              this.setState({
                calorie: (40 *  this.state.weight)
              })
            }
          }

          if(this.state.gender === '帥哥') {
            this.setState({
              idealWeight: Math.round((this.state.height - 80) * 0.7),
              waistLineAndHipsLine: (this.state.waistLine / this.state.hipsLine).toFixed(2)
            })
            if(this.state.waistLineAndHipsLine < 0.92) {
              this.setState({
                waistLineAndHipsLineAns: '(理想範圍, 繼續加油保持喔)'
              })
            } else if (this.state.waistLineAndHipsLine > 0.92) {
              this.setState({
                waistLineAndHipsLineAns: '(數值過高, 請多重視健康管理喔)'
              })
            } else {
              this.setState({
                waistLineAndHipsLineAns: ''
              })
            }
          } else {
            this.setState({
              idealWeight: Math.round((this.state.height - 70) * 0.6),
              waistLineAndHipsLine: (this.state.waistLine / this.state.hipsLine).toFixed(2)
            })
            if(this.state.waistLineAndHipsLine < 0.88) {
              this.setState({
                waistLineAndHipsLineAns: '(理想範圍, 繼續加油保持喔)'
              })
            } else if (this.state.waistLineAndHipsLine > 0.88) {
              this.setState({
                waistLineAndHipsLineAns: '數值過高, 請多重視健康管理喔'
              })
            } else {
              this.setState({
                waistLineAndHipsLineAns: ''
              })
            }
          }

          this.setState({
            idealWeightRange1: Math.round(this.state.idealWeight * 0.9),
            idealWeightRange2: Math.round(this.state.idealWeight * 1.1)
          })

        })
      } else {
        window.location = ('/')
      }
    })
  }

  render() {
    const content = this.state.gender
     ?  <input type="submit" value="儲存吧" className="btnDefault" />
     : null
    var checkAnswerBox = this.state.bmi
     ? <span>( {this.state.answer} )</span>
     : null
    const AnsBox = this.state.bmi
     ? <div>
        <h4>檢測結果:</h4>
         <div className="group" style={Jeyu.answerBox}>
         <p>BMI: {this.state.bmi} {checkAnswerBox}</p>
        </div>
        <div className="group" style={Jeyu.answerBox}>
         <p>理想體重: {this.state.idealWeight} kg</p>
        </div>
        <div className="group" style={Jeyu.answerBox}>
         <p>體重合理範圍: {this.state.idealWeightRange1} kg ~ {this.state.idealWeightRange2} kg</p>
        </div>
        <div className="group" style={Jeyu.answerBox}>
         <p>每日所需熱量: {this.state.calorie} 卡洛里</p>
        </div>
        <div className="group" style={Jeyu.answerBox}>
         <p>腰臀比值: {this.state.waistLineAndHipsLine} {this.state.waistLineAndHipsLineAns} </p>
        </div>
       </div>
     : null



    return(
      <article className="Box">
        <MetaTags>
            <title>草學藥事 || 健康管理工具</title>
            <meta id="og-title" property="og:title" content="健康管理工具" />
        </MetaTags>
       <h3>健康管理工具</h3>
       <form onSubmit={this.handleSave}>

       <div className="groupBox">
       <div className="group">
        <label htmlFor="guy">*性別:</label>
         <input type="radio" value="帥哥"
          checked={this.state.gender === '帥哥'}
          onChange={this.handleChangeGender}
          id="guy" />
         <label className="inlineBlock radio" htmlFor="guy">帥哥</label>
         <input type="radio" value="美女"
          checked={this.state.gender === '美女'}
          onChange={this.handleChangeGender}
          id="beauty" />
         <label className="inlineBlock radio beauty" htmlFor="beauty">美女</label>
       </div>
       </div>

       <div className="tableMasonry3">
        <div className="tgroup">
         <label htmlFor="userHeight">*身高(cm):</label>
         <input type="text" value={this.state.height} id="userHeight" onChange={this.handleChangeHeight} required="true" placeholder="請輸入身高" />
        </div>
        <div className="tgroup">
         <label htmlFor="userWeight">*體重(kg):</label>
         <input type="text" value={this.state.weight} id="userWeight" onChange={this.handleChangeWeight} required="true" placeholder="請輸入體重" />
        </div>
        <div className="tgroup">
         <label htmlFor="userWaistLine">腰圍(cm):</label>
         <input type="text" value={this.state.waistLine} id="userWaistLine" onChange={this.handleChangeWaistLine} placeholder="請輸入腰圍" />
        </div>
        <div className="tgroup">
         <label htmlFor="userHipsLine">臀圍(cm):</label>
         <input type="text" value={this.state.hipsLine} id="userHipsLine" onChange={this.handleChangeHipsLine} placeholder="請輸入臀圍" />
        </div>
       </div>
       <h4>活動量<small>(請依據您的狀況做選擇喔)</small>:</h4>
       <div className="tableMasonry2">
        <div className="tgroup2">
            <input type="radio" value="mildWork"
             checked={this.state.activityAmount === 'mildWork'}
             onChange={this.handleChangeGenderActivityAmount}
             id="activityAmount1" />
            <label className="radio borderblock" htmlFor="activityAmount1">輕度工作：大部分從事靜態或坐著的工作。 <br /><sub>(例如：家庭主婦、坐辦公室的上班族、銷售員)</sub></label>
        </div>
        <div className="tgroup2">
            <input type="radio" value="moderateWork"
             checked={this.state.activityAmount === 'moderateWork'}
             onChange={this.handleChangeGenderActivityAmount}
             id="activityAmount2" />
            <label className="radio borderblock" htmlFor="activityAmount2">中度工作：從事機械操作、接待或家事等站立活動較多的工作。<br /><sub>(例如：褓母、護士、服務生)</sub></label>
        </div>
        <div className="tgroup2">
            <input type="radio" value="heavyWork"
             checked={this.state.activityAmount === 'heavyWork'}
             onChange={this.handleChangeGenderActivityAmount}
             id="activityAmount3" />
            <label className="radio borderblock" htmlFor="activityAmount3">高度工作：從事農耕、漁業、建築等的重度使用體力的工作。<br /> <sub>(例如：運動員、搬家工人)</sub></label>
        </div>
       </div>
        { AnsBox }
        { content }
       </form>
      </article>
    )
  }
}

const Jeyu = {
  answerBox: {
    margin: '10px 0',
    color: '#325aaa'
  }
}



// WEBPACK FOOTER //
// ./src/View/HealthManagementTool.js